var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useMemo, useReducer } from 'react';
import { useRequestedLocation } from '../use-requested-location';
import { AccessTokenContext, } from './access-token-context';
import { CLH_SESSION_ID } from './helpers';
function reducer(state, action) {
    switch (action.type) {
        case 'ACCESS_TOKEN_GRANTED':
            return Object.assign(Object.assign({}, state), { accessToken: action.accessToken, isLoading: false });
        case 'ERROR':
            return Object.assign(Object.assign({}, state), { error: action.error, isLoading: false });
        default:
            return state;
    }
}
export const AccessTokenProvider = (props) => {
    const { audience, redirectUri, children } = props;
    const [state, dispatch] = useReducer(reducer, {
        accessToken: undefined,
        isLoading: true,
    });
    const { user, getAccessTokenSilently, isAuthenticated, loginWithRedirect, isLoading, } = useAuth0();
    const { setRequestedLocation } = useRequestedLocation();
    useEffect(() => {
        if (isLoading) {
            return;
        }
        if (!isAuthenticated) {
            dispatch({ type: 'ERROR', error: new Error('Unauthenticated') });
            return;
        }
        void (() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const accessToken = yield getAccessTokenSilently({
                    authorizationParams: {
                        audience,
                    },
                });
                dispatch({ type: 'ACCESS_TOKEN_GRANTED', accessToken });
            }
            catch (error) {
                dispatch({ type: 'ERROR', error });
            }
        }))();
    }, [audience, getAccessTokenSilently, isAuthenticated, isLoading]);
    useEffect(() => {
        if (state.error) {
            setRequestedLocation(window.location);
            void loginWithRedirect({
                authorizationParams: {
                    redirect_uri: redirectUri,
                    screen_hint: window.location.pathname.includes('/create-account')
                        ? 'signup'
                        : undefined,
                },
            });
        }
    }, [state.error]);
    const contextValue = useMemo(() => {
        return {
            auth0UserId: user === null || user === void 0 ? void 0 : user.sub,
            accessToken: state.accessToken,
            error: state.error,
            isLoading: state.isLoading,
            clhSessionId: CLH_SESSION_ID,
        };
    }, [state]);
    return (_jsx(AccessTokenContext.Provider, { value: contextValue, children: children }));
};
